import { Instagram, Mail, Phone } from "lucide-react"
import MenuSection from "../components/MenuSection"
import { menuData } from "../data/menu-data"

function HomePage() {
  return (
    <main className="min-h-screen bg-amber-50">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-gradient-to-r from-amber-800 to-amber-600">
        <div className="absolute inset-0 bg-black/40" />
        <div className="container mx-auto px-4 h-full flex flex-col items-center justify-center relative z-10 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4">Chai Baghan</h1>
          <p className="text-xl md:text-2xl text-amber-100 font-medium">All Natural All Fresh</p>
        </div>
      </section>

      {/* Menu Sections */}
      <section className="container mx-auto py-12 px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {menuData.map((section) => (
            <MenuSection
              key={section.title}
              title={section.title}
              items={section.items}
              highlight={section.highlight}
              color={section.color}
            />
          ))}
        </div>
      </section>

      {/* Special Occasions */}
      <section className="bg-green-800 text-white py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
            <span className="inline-block bg-green-700 px-6 py-2 rounded-lg">Special Occasion Celebration</span>
          </h2>
          <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <ul className="text-xl space-y-4">
              <li className="flex items-center">
                <span className="w-4 h-4 bg-amber-400 rounded-full mr-3"></span>
                Birthday Party
              </li>
              <li className="flex items-center">
                <span className="w-4 h-4 bg-amber-400 rounded-full mr-3"></span>
                Kitty Party
              </li>
              <li className="flex items-center">
                <span className="w-4 h-4 bg-amber-400 rounded-full mr-3"></span>
                Anniversary Party
              </li>
              <li className="flex items-center">
                <span className="w-4 h-4 bg-amber-400 rounded-full mr-3"></span>
                Hall Available
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="bg-amber-900 text-white py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
            <a
              href="https://instagram.com/Chai_Baghan"
              className="flex items-center gap-2 hover:text-amber-200 transition-colors"
            >
              <Instagram className="w-6 h-6" />
              <span>@Chai_Baghan</span>
            </a>
            <a href="tel:8770926041" className="flex items-center gap-2 hover:text-amber-200 transition-colors">
              <Phone className="w-6 h-6" />
              <span>8770926041, 7828330368</span>
            </a>
            <a
              href="mailto:pankajjai.samrat@gmail.com"
              className="flex items-center gap-2 hover:text-amber-200 transition-colors"
            >
              <Mail className="w-6 h-6" />
              <span>pankajjai.samrat@gmail.com</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-amber-950 text-amber-200 py-6 text-center">
        <div className="container mx-auto px-4">
          <p>© {new Date().getFullYear()} Chai Baghan. All rights reserved.</p>
        </div>
      </footer>
    </main>
  )
}

export default HomePage
